import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { authActions } from "../../store/auth";
const Support = () => {
  const dispatch = useDispatch();
  //   const access = useSelector((state) => state.auth.access);
  const subdomain_name = useSelector(state => state.auth.product.subdomain_name)

  useEffect(() => {
    dispatch(authActions.setLoaderStatus({ status: false }));
  });

  const meta_data = useSelector(state => state.auth.product.meta_data)
  const logo = meta_data && JSON.parse(meta_data).subdomainLogo ? JSON.parse(meta_data).subdomainLogo : `${process.env.PUBLIC_URL}/newlogo.png`;


  return (
    <>
      <section className="mid_wrap">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-4 pb-2">
              <li className="breadcrumb-item">
                <Link to="/">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Support
              </li>
            </ol>
          </nav>
          <div className="row">
            <div className="col-md-12 mb-4">
              <div className="bx_a">
                <div className="emptyDiv">
                  <img
                    src={logo}
                    alt="img"
                    className="mt-4"
                  />
                  <br />
                  <h2>Welcome to {subdomain_name} Dashboard</h2>

                  <h5 className="mt-3 text-muted">
                    <b>Contact Support by clicking the button below</b>
                  </h5>
                  <a
                    className="btn mt-3"
                    href="https://engageleads.zendesk.com/hc/en-us"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Click here to ask your queries.
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Support;
